import { combineReducers } from '@reduxjs/toolkit';
import authorizationSequencing from './authorization-sequencing/store/authorizationSequencingSlice';
import selfAuthorizations from './self-authorizations/store/selfAuthorizationsSlice';
import createNewSelfAuth from './self-authorizations/store/createNewSelfAuthorizationSlice';
import createNewSupplierAuth from './supplier-authorizations/store/createNewSupplierAuthSlice';
import createNewCarrierAuthSlice from './carrier-authorizations/store/createNewCarrierAuthSlice';
import myAuthorizations from './my-authorizations/store/myAuthorizationsSlice';
import carrierAuthorizations from './carrier-authorizations/store/carrierAuthorizationsSlice';
import supplierAuthorizations from './supplier-authorizations/store/supplierAuthorizationSlice';
import mobileDrawer from './mobile-drawer/store/mobileDrawerSlice';
import filters from './filters/store/filtersSlice';
import sequencingWizard from './authorization-sequencing/sequencing-wizard/store/sequencingWizardSlice';
import rackWaitTimes from './terminal-information/rack-wait-times/store/rackWaitTimesSlice';
import terminalLocator from './terminal-information/terminal-locator/store/terminalLocatorSlice';
import customerAuthorizations from './customer-authorizations/store/customerAuthorizationSlice';

export default combineReducers({
  authorizationSequencing,
  carrierAuthorizations,
  createNewCarrierAuth: createNewCarrierAuthSlice,
  createNewSelfAuth,
  createNewSupplierAuth,
  customerAuthorizations,
  filters,
  mobileDrawer,
  myAuthorizations,
  rackWaitTimes,
  selfAuthorizations,
  sequencingWizard,
  supplierAuthorizations,
  terminalLocator,
});
